import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpContextToken,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';

const helper = new JwtHelperService();

export const BYPASS_LOG = new HttpContextToken(() => true);
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor() {}
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    let skipedAPIs = ['sendOTP','validateOTP', 'updateUserReportingPreferences', 'active-acceptance-terms'];
    let isSkipped = skipedAPIs.some((api) => request.url.toLowerCase().includes(api.toLowerCase()));

    // check if the request is to bypass the interceptor
    if (request.context.get(BYPASS_LOG) === true && request.url.includes('/api/') && !isSkipped) {
      
      const rawUser = localStorage.getItem('currentUser');
      const currentUser = rawUser ? JSON.parse(rawUser) : null;

      if (currentUser && currentUser.authenticated && currentUser.authenticated.access_token) {
        
        if (!helper.isTokenExpired(currentUser.authenticated.access_token)) {
          const cloned = request.clone({
            setHeaders: {
              Authorization: `Bearer ${currentUser.authenticated.access_token}`,
              boardId: currentUser.board?.id ?? ''
            },
          });
          return next.handle(cloned);
        }
      }

      return next.handle(request);
    }

    return next.handle(request);
  }
}
